<div class="px-6 gap-6 flex flex-col pb-40">
  <div class="flex items-center justify-end w-full" *ngIf="showSkip">
    <div class="flex flex-col items-center text-white">
      <div
        class="h-6 w-6 text-center rounded-full portal-builder-num  bg-primary"
      >
        1
      </div>
      <span class="text-white ">Registration</span>
    </div>
    <div class="w-40 h-[2px] bg-primary"></div>
    <div class="flex flex-col items-center">
      <div class="h-6 w-6 text-center rounded-full bg-primary text-white">
        2
      </div>
      <span class="text-white ">Portal Builder</span>
    </div>
  </div>
  <form
    [formGroup]="portalBuilderForm"
    class="login-container w-full px-6 gap-6 flex flex-col pb-40"
  >
    <div class="w-full flex flex-col bg-white rounded-xl pb-6">
      <div
        class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex justify-between w-full">
          <div class="flex gap-4">
            <div class="h-10 w-1 bg-primary"></div>
            <span>Business Settings</span>
          </div>
          <app-primary-button
            routerLink="/home/customer/partnerProfile"
            *ngIf="showSkip"
            >Skip
          </app-primary-button>
        </div>
      </div>
      <div class="p-5 w-full flex gap-6 items-center justify-center">
        <div
          *ngFor="let item of cards"
          class="flex flex-col gap-8 py-4   shadow-xl border rounded-xl w-full h-60 justify-between"
        >
          <div
            class="border-[3px] px-2 border-transparent border-b-gray-300 border-l-primary"
          >
            {{ item.heading }}
          </div>
          <img *ngIf="item.logo" src="{{ item.logo }}" alt="" class="h-20  mx-5 w-fit" />
       
          <div class="flex justify-center items-center ">
            <label
              [for]="item.type"
              class="bg-gradient-to-r from-primary to-semiPrimary text-white w-40 text-white text-center rounded-2xl p-3   cursor-pointer"
            >
              <span>{{ item.button }}</span>
              <input
                [id]="item.type"
                type="file"
                class="visually-hidden"
                (change)="onFileSelected($event, item.type)"
                accept="image/*"
              />
            </label>
          </div>
        </div>
      </div>

      <div class="px-5 w-75 flex gap-5" >
        <div class="w-100 ">
          <span> Partner Name</span>

          <input
            formControlName="title"
            name="title"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Your Title text"
          />
        </div>
        <div class="mx-4"  >
          <span>Select Language</span>

          <select
            (change)="onLanguageSelect($event)"
            class="w-full border p-2 rounded-md outline-none"
            formControlName="defaultLanguage"
            name="defaultLanguage"
          >
            <option value="" disabled>Select Language</option>
            <option
              *ngFor="let language of languageList"
              [value]="language._id"
            >
              {{ language?.title }}
            </option>
          </select>
        </div>
      </div>

      <div class="p-5 flex flex-col gap-4">
        <span class="text-lg">Theme Customizer</span>
        <div class="flex gap-6 flex-col lg:flex-row">
          <div>
            <div *ngIf="roleId == 'admin'" class="flex flex-col gap-2">
              <span class="flex gap-4">
                <img
                  src="../../assets/image/selected-color.svg"
                  alt=""
                />Primary color Settings</span
              >
              <div class="grid grid-cols-5 w-fit gap-1">
                <button
                  *ngFor="let c of colors" type="button"
                  class="w-10 h-6 border-black"
                  [ngStyle]="{
                    backgroundColor: c.colorCode,
                    borderWidth: selectedColor == c.colorCode ? '2px' : 0
                  }"
                  (click)="onPrimeryColorChange(c.colorCode)"
                ></button>
              </div>
            </div>
          </div>
          <div>
            <div *ngIf="roleId == 'admin'" class="flex flex-col gap-2">
              <span class="flex gap-4">
                <img src="../../assets/image/selected-color.svg" alt="" />
                Secondary color Settings</span
              >
              <div class="grid grid-cols-5 w-fit gap-1">
                <button type="button"
                  *ngFor="let c of colors"
                  class="w-10 h-6 border-black"
                  [ngStyle]="{
                    backgroundColor: c.colorCode,
                    borderWidth:
                      selectedSecoundaryColor == c.colorCode ? '2px' : 0
                  }"
                  (click)="onSecondaryColorChange(c.colorCode)"
                ></button>
              </div>
            </div>
          </div>

          <div class="lg:pl-20" *ngIf="roleId == 'admin'">
            <div class="flex flex-col gap-2">
              <span class="flex gap-4">
                <img src="../../assets/image/selected-color.svg" alt="" />
                Selected color
              </span>
              <div class="flex gap-6">
                <div class="flex flex-col gap-1">
                  <span>Primary</span>
                  <button
                    class="w-10 h-6 border-[2px] border-black"
                    [ngStyle]="{
                      backgroundColor: selectedColor
                    }"
                  ></button>
                  <span class="tex">{{ selectedColor }}</span>
                </div>
                <div class="flex flex-col gap-1">
                  <span>Secondary</span>
                  <button
                    class="w-10 h-6 border-[2px] border-black"
                    [ngStyle]="{
                      backgroundColor: selectedSecoundaryColor
                    }"
                  ></button>
                  <span>{{ selectedSecoundaryColor }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="themeLookText">{{ themeLookText }}</div>
    </div>

    <!-- System Settings -->
    <div class="w-full flex flex-col bg-white rounded-xl pb-6">
      <div
        class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex gap-4 w-full">
          <div class="h-10 w-1 bg-primary"></div>
          <span>System Settings</span>
        </div>
      </div>
      <div class="flex gap-4 w-full p-5">
        <div class="w-full flex flex-col gap-2">
          <span>Currency </span>
          <select
            class="w-full p-2 outline-none border rounded-md"
            formControlName="currency"
            placeholder="Enter currency"
            name="currency"
            (change)="onCurrencySelect($event)"
          >
            <option value="" disabled>Select Currency</option>
            <option
              *ngFor="let currency of currencyData"
              [value]="currency._id"
            >
              {{ currency?.title }}
            </option>
          </select>
          <!-- selectInput="USD" /> -->
        </div>
        <div class="w-full flex flex-col gap-2">
          <span>Currency Symbol </span>
          <select 
            class="w-full p-2 outline-none border rounded-md"
            formControlName="currencySymbol"
            name="currencySymbol"
          >
          <option value="" disabled>Select Currency Symbol</option>
            <option
              *ngFor="let currency of currencySymbolData"
              [value]="currency.symbol"
            >
              {{ currency?.symbol }}
            </option>
          </select>
        </div>
      </div>

      <div class="flex gap-4 w-full p-5">
        <div class="w-full flex flex-col gap-2"></div>
      </div>
    </div>
    <!-- Bank News -->
    <div class="w-full flex flex-col bg-white rounded-xl pb-6">
      <div
        class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex gap-4">
          <div class="h-10 w-1 bg-primary"></div>
          <span>Bank News</span>
        </div>
      </div>
      <div class="flex gap-4 w-full p-5">
        <div class="w-full flex flex-col gap-2">
          <span> News</span>
          <input
            formControlName="news"
            name="news"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter News"
          />
        </div>
        <div class="w-full flex flex-col gap-2">
          <span>Bill Notice</span>
          <input
            formControlName="billNotice"
            name="billNotice"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Notice"
          />
        </div>
        <div class="w-full flex flex-col gap-2"></div>
      </div>
    </div>

    <!-- Bank Serrings -->
    <div class="w-full flex flex-col bg-white rounded-xl pb-6">
      <div
        class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex gap-4">
          <div class="h-10 w-1 bg-primary"></div>
          <span>Bank Notice</span>
        </div>
      </div>
      <div class="h-[500px] w-full p-5">
        <angular-editor
          id="editor1"
          formControlName="bankNotice"
          name="bankNotice"
          [config]="editorConfig"
        >
          <ng-template #customButtons let-executeCommandFn="executeCommandFn">
            <ae-toolbar-set>
              <ae-button
                iconClass="fa fa-html5"
                title="Angular editor logo"
                (buttonClick)="executeCommandFn('insertHtml')"
              >
              </ae-button>
            </ae-toolbar-set>
          </ng-template>
        </angular-editor>
      </div>
    </div>
    <!-- Bank Settins -->
    <div class="w-full flex flex-col bg-white rounded-xl pb-6">
      <div
        class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex gap-4">
          <div class="h-10 w-1 bg-primary"></div>
          <span>Bank Setting</span>
        </div>
      </div>
      <div class="grid grid-cols-3 p-5 gap-4">
        <div *ngFor="let items of bankSettingForm" class="flex flex-col gap-2">
          <div *ngIf="items.heading != 'Telephone' && items.heading != 'Zip/Post Code'">
            <span>{{ items.heading }} *</span>
            <input
              [formControlName]="items.formControlName"
              name="items.formControlName"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="{{ items.placeholder }}"
            />
              <div
              *ngIf="
                portalBuilderForm.controls[items.formControlName].touched &&
                !portalBuilderForm.controls[items.formControlName].valid
              "
              class="text-red-500"
            >
              {{ items.errorMsg }}
            </div>
          
          </div>
          <div *ngIf="items.heading == 'Zip/Post Code'">
            <span>{{ items.heading }} *</span>
            <input  (keypress)="keyPressNumbers($event)"
              [formControlName]="items.formControlName"
              name="items.formControlName"   maxlength="6"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="{{ items.placeholder }}"
            />
            <div
            *ngIf="
              portalBuilderForm.controls[items.formControlName].touched &&
              !portalBuilderForm.controls[items.formControlName].valid
            "
            class="text-red-500"
          >
            {{ items.errorMsg }}
          </div>
          </div>
          <div *ngIf="items.heading == 'Telephone'">
            <span>{{ items.heading }} *</span>
            <input
              (keypress)="keyPressNumbers($event)"
              [formControlName]="items.formControlName"
              name="items.formControlName"
              maxlength="10"
              class="w-full border p-2 rounded-md outline-none"
              placeholder="{{ items.placeholder }}"
            />
            <div
            *ngIf="
              portalBuilderForm.controls[items.formControlName].touched &&
              !portalBuilderForm.controls[items.formControlName].valid
            "
            class="text-red-500"
          >
            {{ items.errorMsg }}
          </div>
          </div>
        </div>
        <div class="flex flex-col gap-2" style="line-height: 16px;">
          <span> Country *</span>
          <select
            class="w-full p-2 outline-none border rounded-md"
            formControlName="country"
            name="country"
            (change)="onCountrySelect($event)"
          >
          <option value="" selected disabled>India</option>
          
          </select>
          <!-- <div
          *ngIf="
            portalBuilderForm.controls['country'].touched &&
            !portalBuilderForm.controls['country'].valid
          "
          class="text-red-500"
        >
          Select Valid Country
        </div> -->
        </div>
        <div class="flex flex-col gap-2">
          <span> State *</span>
          <select
            class="w-full p-2 outline-none border rounded-md"
            formControlName="state"
            name="state"
            (change)="onStateSelect($event)"
          >
          <option value="" disabled>Select State</option>
            <option *ngFor="let state of stateData" [value]="state?._id">
              {{ state?.title }}
            </option>
          </select>
          <div
          *ngIf="
            portalBuilderForm.controls['state'].touched &&
            !portalBuilderForm.controls['state'].valid
          "
          class="text-red-500"
        >
          Select valid state
        </div>
        </div>

        <div class="flex flex-col gap-2">
          <span> City *</span>
          <select 
            class="w-full p-2 outline-none border rounded-md"
            formControlName="city"
            name="city"
            (change)="onCitySelect($event)"
          >
          <option value="" disabled>Select City</option>
            <option *ngFor="let city of cityData" [value]="city?._id">
              {{ city?.title }}
            </option>
          </select>
          <div
          *ngIf="
            portalBuilderForm.controls['city'].touched &&
            !portalBuilderForm.controls['city'].valid
          "
          class="text-red-500"
        >
          Select valid city
        </div>
        </div>
      </div>

      <div class="p-5 gap-4 flex items-center">
        <div class="flex flex-col gap-2">
          <span> Timezone *</span>
          <select
            class="w-full p-2 outline-none border rounded-md"
            formControlName="bankTimeZone"
            name="bankTimeZone"
          >
            <option value="" disabled>Select TimeZone</option>
            <option value="(GMT+5:30) Asia /Kolkata (india standard Time)">
              (GMT+5:30) Asia /Kolkata (india standard Time)
            </option>
          </select>
          <div
          *ngIf="
            portalBuilderForm.controls['bankTimeZone'].touched &&
            !portalBuilderForm.controls['bankTimeZone'].valid
          "
          class="text-red-500"
        >
          Select valid timeZone
        </div>
        </div>
      </div>
      <div class="p-5 gap-4 grid grid-cols-3 items-center">
        <div class="flex flex-col gap-2">
          <span> Support Contact Number *</span>
          <input maxlength="10"
            (keypress)="keyPressNumbers($event)"
            formControlName="supportContactNumber"
            name="supportContactNumber"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Support Contact Number"
          />
          <div
          *ngIf="
            portalBuilderForm.controls['supportContactNumber'].touched
             &&
            !portalBuilderForm.controls['supportContactNumber'].valid
          "  class="text-red-500"
        > Enter valid contact number
      </div>
        </div>
        <div class="flex flex-col gap-2">
          <span>Support Email *</span>
          <input
            formControlName="supportContactEmail"
            name="supportContactEmail"
            type="email"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Support Email"
          />   <div
          *ngIf="
            portalBuilderForm.controls['supportContactEmail'].touched &&
            !portalBuilderForm.controls['supportContactEmail'].valid
          "  class="text-red-500"
        > Enter valid contact email
      </div>
        </div>
      </div>
    </div>
    <!-- Scheme Setting -->
    <div class="w-full flex flex-col bg-white rounded-xl pb-6">
      <div
        class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex gap-4">
          <div class="h-10 w-1 bg-primary"></div>
          <span>Commision Type</span>
        </div>
      </div>
      <div class="flex flex-col gap-6">
        <div>
          <div class="w-full bg-gray-300 p-2 px-6 text-primary">PayIn *</div>
          <div class="w-full flex gap-6 p-5">
            <div class="w-full flex flex-col gap-4">
              <span>Commission Type</span>
              <select
                class="border p-2 outline-none rounded-md"
                formControlName="chargeType"
              >
                <option value="" disabled class="text-gray-400">
                  -- Select Commission Type --
                </option>

                <option value="flat">Flat</option>
                <option value="percentage">Percentage</option>
              </select>
            </div>
            <div class="w-full flex flex-col gap-4">
              <span>Commission On Partner</span>
              <input type="number"
              [readonly]="!portalBuilderForm.get('chargeType')?.value"
                min="0"
                [maxlength]="portalBuilderForm.get('chargeType')?.value == 'percentage' ? 3 : null"
                [max]="portalBuilderForm.get('chargeType')?.value == 'percentage' ? 100 : null"
                formControlName="payInPartner"
                name="payInPartner"
                class="border p-2 rounded-md outline-none"
                placeholder="Enter Commission On Partner"/>
                <div *ngIf="
                (portalBuilderForm.controls['payInPartner'].touched &&
                !portalBuilderForm.controls['payInPartner'].valid) 
              "
              class="text-red-500">
        Invalid format or value. Please enter a valid number with up to two decimal places.
        </div>
            </div>
          </div>
        </div>
        <!-- PayOut -->
        <div class="gap-4 flex flex-col">
          <div class="w-full bg-gray-300 p-2 px-6 text-primary">PayOut *</div>
          <table class="w-full">
            <tr class="w-full border">
              <th class="text-left">Range</th>
              <th class="text-left">Commission Types</th>
              <th class="text-left">Commission on Partner</th>
            </tr>
            <tr *ngFor="let item of payOutTableData">
              <td class="border p-2">{{ item.range }}</td>
              <td class="border p-2">
                <select
                  class="w-full outline-none"
                  [formControlName]="item.rangeChargeType"
                >
                  <option value="" disabled selected class="text-gray-100">
                    -- Select Type --
                  </option>
                  <option value="flat">Flat</option>
                  <option value="percentage">Percentage</option>
                </select>
              </td>
              <td class="border">
                <input   type="number"
                [readonly]="!portalBuilderForm.get(item.rangeChargeType)?.value"
                min="0"
                [max]="portalBuilderForm.get(item.rangeChargeType)?.value == 'percentage' ? 100 : null"
                [maxlength]="portalBuilderForm.get(item.rangeChargeType)?.value == 'percentage' ? 3 : null"
                  [formControlName]="item.rangeChargePartner"
                  placeholder="Enter Commission"
                  class="outline-none w-full"
                />
                
              </td>
            </tr>
          </table>
          <div
          *ngIf="
            (portalBuilderForm.controls['chargePartnerOne'].touched &&
            !portalBuilderForm.controls['chargePartnerOne'].valid) 
            || (portalBuilderForm.controls['chargePartnerTwo'].touched &&
            !portalBuilderForm.controls['chargePartnerTwo'].valid) || 
            (portalBuilderForm.controls['chargePartnerThree'].touched &&
            !portalBuilderForm.controls['chargePartnerThree'].valid)
          "
          class="text-red-500"
        >
        Invalid format or value. Please enter a valid number with up to two decimal places.
        </div>
        </div>
      </div>
    </div>
    <div
      class="w-full bg-white p-2 rounded-xl flex gap-4 px-5 justify-end items-center"
    >
      <app-primary-button (click)="createPortalBuilder()">Save</app-primary-button>
    </div>
  </form>
</div>
